import { request } from '../@utils'
import { requestFile } from '../@utils'

const DeliveryService = {
  /**
   * 订单发货
   * @param params
   * @returns {Promise<AxiosResponse<any>>}
   */
  delivery: params => {
    return request.post('order-delivery/delivery', { data: params })
  },
  /**
   * 查询订单发货详情
   * @param orderNo
   * @returns {Promise<AxiosResponse<any>>}
   */
  detailByNo: orderNo => {
    return request.get(`order-delivery/detail/${orderNo}`)
  },
  /**
   * 导出订单发货列表
   * @param data
   * @returns {Promise<AxiosResponse<any>>}
   */
  exportOrderDelivery: data => {
    return requestFile.post(`order-delivery/export`, {
      data: data,
      responseType: 'blob'
    })
  },
  /**
   * 查询订单发货列表（分页)
   * @param params
   * @returns {Promise<AxiosResponse<any>>}
   */
  deliveryList: params=>{
    return request.post('order-delivery/list', { data: params })
  },
  /**
   * 发货信息修改
   * @param params
   * @returns {Promise<AxiosResponse<any>>}
   */
  updateDelivery: params=>{
    return request.post('order-delivery/update-delivery', { data: params })
  },
  addFileTask: async params => {
    const res = await request.post('/order-delivery/import', { data: params })
    return res
  },
  companiesList: params => {
    return request.post('order-delivery/companies', { data: params })
  },

}
export default DeliveryService
